<template>
  <q-page padding>   
    <div class="row margin">
      <div class="col q-pa-sm">
        <h4>Neues WTracking Test Konto Eröffnen</h4>
      </div>
    </div>
  <div class="row margin">
      <div class="col q-pa-sm">
        <q-input class="email" type="email" :float-label="$t('global.UserEmail')" placeholder="Wir senden Ihr Passwort an diese Adresse"  v-model="email" lazy-rules :rules="[val => !!val || 'Email Adresse Ungültig', isValidEmail]"  />      
      </div> 
      <div class="col q-pa-sm">
      <q-input float-label="Name" placeholder="Name Ihrer Firma oder Organisation"  type="text" v-model="name"  />
    </div> 
  </div>
<div class="row">
    <div class="col q-pa-sm">
      <q-input float-label="Vorname" placeholder="Administation Benutzer Vorname"  type="text" v-model="nameFirst"  />
    </div> 
    <div class="col q-pa-sm">
      <q-input float-label="Nachname" placeholder="Administration Benutzer Nachname"  type="text" v-model="nameLast"  />
    </div> 
</div>
<div class="row">
  <div class="col q-pa-sm">
    <q-input float-label="Telefon" placeholder="Wo können wir sie erreichen"  type="text" v-model="phone"  />
  </div>
  <div class="col q-pa-sm">
    <q-input float-label="Addresse" placeholder="Ihre gültige Post Addresse"  type="textarea"  v-model="address" rows="3" :max-height="100"  />
  </div>  
</div>
<hr>
<div class="row">
  <div class="col-6 q-pa-sm">
    <q-input float-label="Mitarbeiter Kategorie - Administration" placeholder="Mitarbeiter Kategorie Administrator"  type="text" v-model="UserCategory1"  />  
  </div>
  <div class="col-6 q-pa-sm">
    <q-input float-label="Mitarbeiter Kategorie - 2" placeholder="Mitarbeiter Kategorie 2"  type="text" v-model="UserCategory2"  />  
  </div>
  <div class="col-6 q-pa-sm">
    <q-input float-label="Mitarbeiter Kategorie - 3" placeholder="Mitarbeiter Kategorie 3"  type="text" v-model="UserCategory3"  />  
  </div>
  <div class="col-6 q-pa-sm">
    <q-input float-label="Mitarbeiter Kategorie - 4" placeholder="Mitarbeiter Kategorie 4"  type="text" v-model="UserCategory4"  />  
  </div>

</div>
<hr>
<div class="row">
  <div class="col-6 q-pa-sm">
     <q-input float-label="Event Art" placeholder="Event Art"  type="text" v-model="EventType"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Produkte Gruppe" placeholder="Produkte Gruppe"  type="text" v-model="ProductGroup"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Produkt 1" placeholder="Produkt 1"  type="text" v-model="Product1"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Produkt 2" placeholder="Produkt 2   Produkt"  type="text" v-model="Product2"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Resoruce 1" placeholder="Resource 1"  type="text" v-model="ResourceHour"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Kosten pro Stunde" placeholder="Kosten pro Stunde"  type="number" v-model="CostPerHour"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Resource 2" placeholder="Resource 2"  type="text" v-model="ResourceFix"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Kosten pro Auftrag" placeholder="Kosten pro Auftrag"  type="number" v-model="CostFix"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Resource 3" placeholder="Resource 3"  type="text" v-model="ResourceHa"  />  
  </div>
  <div class="col-6 q-pa-sm">
     <q-input float-label="Kosten pro Hektare" placeholder="Kosten pro Hektare"  type="number" v-model="CostHa"  />  
  </div>
</div>
<hr>
<div class="row">
  <div class="col q-pa-sm">
    <q-btn :disable="valid == false"  type="submit"  color="primary"  label="Neues Konto Eröffnen" @click="openAccount" :loading="submitting" />
  </div>
</div>
</q-page>
</template>
<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'
import { duration } from 'moment'

export default {
  name: 'Login',
  data: function () {
    return {
      alert: false,
      submitting: false,
      form: {
        action: 'Signup'
      },
      email: null,
      name: null,
      nameFirst: null,
      nameLast: null,
      phone: null,
      address: null,

      UserCategory1: 'Betriebsleitung',
      UserCategory2: 'Vorarbeiter',
      UserCategory3: 'Angestellte/r',
      UserCategory4: 'Angestellte/r Stundenlohn',
      EventType: 'Pflanzenschutz',
      ProductGroup: 'Trauben',
      Product1: 'Weiss',
      Product2:'Rot',
      ResourceHour: 'Fahrzeug pro Stunde',
      CostPerHour: 50.2,
      ResourceFix: 'Material pro Auftrag',
      CostFix:  17.50,
      ResourceHa: 'Material pro Hektare',
      CostHa: 1750,

      
    }
  },
  
  methods: {
    openAccount () {
      this.submitting = true
      var isDST = this.moment().isDST()
      var d = new Date();
      var n = d.getTimezoneOffset();
      this.form.action = "signup"
      this.form.TimezoneOffset = n
      this.form.IsDST = isDST //Add DST 
      this.form.name = this.name
      this.form.email = this.email
      this.form.nameFirst = this.nameFirst
      this.form.nameLast = this.nameLast
      this.form.address = this.address
      this.form.phone = this.phone

      this.form.UserCategory1 = this.UserCategory1
      this.form.UserCategory2 = this.UserCategory2
      this.form.UserCategory3 = this.UserCategory2
      this.form.UserCategory4 = this.UserCategory4
      this.form.EventType = this.EventType
      this.form.ProductGroup = this.ProductGroup
      this.form.Product1 = this.Product1
      this.form.Product2 = this.Product2
      this.form.ResourceHour = this.ResourceHour
      this.form.CostPerHour = this.CostPerHour
      this.form.ResourceFix = this.ResourceFix
      this.form.CostFix = this.CostFix
      this.form.ResourceHa = this.ResourceHa
      this.form.CostHa = this.CostHa

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded', }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                  this.$q.notify({ message: 'WTracking Konto geöffnet, Zugangs-E-Mail gesendet.', type: 'positive' })
                  this.$router.push({name: 'Login'})
                  return
              }
              if(response.data == "-1"){
                this.$q.notify({ message: 'Diese Emailadresse wird schon verwendet.', type: 'negative' })
              }
              else{
                  this.$q.notify('Wrong Credentials, please review fields again.')
              }
          }
          else{
              this.$store.dispatch('setSession', null)
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
          this.submitting = false
          this.$q.notify('Something Wrong.')
          console.log(e);
          this.$store.dispatch('setSession', null)
      })
    },
    isValidEmail (val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || 'Ungültige Email Adresse';
    }

  },
  computed: {
    valid: function () {
      if (this.isValidEmail(this.email) == 'Ungültige Email Adresse')
        return false

      if(!this.name)
        return false
      if(!this.nameFirst)
        return false
      if(!this.nameLast)
        return false
      if(!this.phone)
        return false
      if(!this.address)
        return false
        
      return true
      
    }
    
  },
  mounted: function () {
            //Set user and password for demo site:
            
    },
}
</script>

<style scoped>
.content{
  padding: 10px;
}
.email{
  width: 100%;
}
.margin{
  color: green;
  margin-top: -50px;
}
</style>

